<!--  -->
<template>
  <div class="progress-tem">
      <tem-head :globalConfig='globalConfig' v-if="temData.title" :text="temData.title" />
      <div class="progress-tem-content" :style="temData.hasBorder ? setStyle:''">
        <Progress
          :main='globalConfig.main'
          :list="temData.flowItemList"
          @titleClick="handleTitleClick"
          :ancillaryColor="globalConfig.vice"
        />
      </div>
      
  </div>
</template>

<script>
import TemHead from '@/components/TemHead'
import Progress from '@/components/Progress'
import { mapState, mapActions, mapGetters } from 'vuex'
import { showCheckNet } from '@/components/checknetwork/index'

export default {
  props: {
    temData: {
      type: Object
    }
  },
  data () {
    return {
    };
  },

  components: {
    TemHead,
    Progress
  },

  computed: {
    ...mapState({
        globalConfig: state => state.router.globalConfig,
        userInfo: state => state.user.userInfo,
        routeList: state => state.router.routeList,
    }),
    ...mapGetters(['loginStatus']),
    setStyle(){
      const border = {
        'border-width': '1px',
        'border-style': 'solid',
        'border-radius': '8px'
      }
      return{
        borderColor:this.globalConfig.vice,
        ...border
      }
    },
  },

  mounted() {
    
  },

  methods: {
    ...mapActions([
      'setUserDiaLog'
    ]),
    handleTitleClick({ linkedPage}) {
      const handleLinkedPage = {
        '-2': () => {
          if (this.loginStatus) {
            this.setUserDiaLog({isShowDiaLog:false, currentVal:'login'});
          } else {
            this.setUserDiaLog({isShowDiaLog:true, currentVal:'login'});
          }
        },
        '-3':() => {
          showCheckNet()
        }
      }
      if (linkedPage >= 0 && this.$route.path !== `/${linkedPage}`) {
        if (this.routeList[0].id === linkedPage) {
          this.$router.push({
            path: '/'
          })
        } else {
          this.$router.push({
            path: `/${linkedPage}`
          })
        }
      } else {
        handleLinkedPage[linkedPage]();
      }
    }
  }
}

</script>
<style lang='less' scoped>
.progress-tem {
  .progress-tem-content{
    width: 1100px;
    height: auto;
    margin:25px auto 0;
  }
}
</style>